<template>
  <div class="relative transition-color duration-300" :style="{ width: `${size}px`, height: `${size}px` }"
  :class="isValid ? 'text-secondary-green-100' : 'text-neutral-alpha-500'">
    <transition>
      <svg v-if="isValid" class="absolute top-0 left-0 w-full h-full" key="valid-check"
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 20 20" fill="none">
        <path d="M16.75 10C16.75 13.728 13.728 16.75 10 16.75C6.27208 16.75 3.25 13.728 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.728 3.25 16.75 6.27208 16.75 10Z" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.25 8.125L8.875 12.25L7.375 10.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else class="absolute top-0 left-0 w-full h-full" key="invalid-check"
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 20 20" fill="none">
        <path d="M16.75 10C16.75 13.728 13.728 16.75 10 16.75C6.27208 16.75 3.25 13.728 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.728 3.25 16.75 6.27208 16.75 10Z" 
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.75 7.75L12.25 12.25M12.25 7.75L7.75 12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ValidityAnimatedIcon',
  props: {
    isValid: {
      type: Boolean,
      required: true
    },
    size: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity 100ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>